function CalendarWeekdayTitles() {
  return (
    <>
    <div className="ncal-cell ncal-cell__title" >Mo</div>
    <div className="ncal-cell ncal-cell__title" >Di</div>
    <div className="ncal-cell ncal-cell__title" >Mi</div>
    <div className="ncal-cell ncal-cell__title" >Do</div>
    <div className="ncal-cell ncal-cell__title" >Fr</div>
    <div className="ncal-cell ncal-cell__title" >Sa</div>
    <div className="ncal-cell ncal-cell__title" >So</div>
    </>
  )
}

export default CalendarWeekdayTitles